import { useState } from "react";

export default function PublishBand() {
  const [draft, setDraft] = useState("");
  const [sent, setSent] = useState(false);

  return (
    <section id="publish" className="w-full scroll-mt-24 border-y border-background-200 bg-background-100/60">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 py-10 md:grid-cols-[0.9fr_1.1fr] md:px-6 md:py-12">
        <div>
          <span className="flex w-max items-center gap-1.5 whitespace-nowrap rounded-sm bg-primary-500 px-2 py-1 text-xs font-semibold text-background-50">
            <i className="ri-megaphone-line" />
            线索征集
          </span>
          <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-foreground-950">
            你在现场，你就是信源
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
            拍到现场、录到同期声、手上有一手材料？把你知道的告诉我们。编辑部核验后会第一时间跟进，投稿可匿名。
          </p>
          <ul className="mt-5 flex flex-col gap-2 text-sm text-foreground-600">
            {["提交线索后 24 小时内专人对接", "附时间线与凭证的可信度更高", "匿名投稿将做脱敏处理"].map((t) => (
              <li key={t} className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-primary-500" />
                {t}
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
          <p className="mb-2 flex items-center gap-1.5 text-sm font-semibold text-foreground-900">
            <i className="ri-edit-2-line text-primary-600" />
            快速起稿 · 仅在本机暂存
          </p>
          <textarea
            value={draft}
            onChange={(e) => {
              setDraft(e.target.value);
              if (sent) setSent(false);
            }}
            maxLength={500}
            rows={5}
            placeholder="一句话说清楚：什么时间、什么地点、发生了什么。尽量附上你能记得的关键细节……"
            className="w-full resize-none rounded-md border border-background-300 bg-background-50 p-3 text-sm leading-relaxed outline-none transition-colors placeholder:text-foreground-300 focus:border-primary-400"
          />
          <div className="mt-1 flex justify-end text-xs text-foreground-300">
            {draft.length}/500
          </div>
          <div className="mt-2 flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-1 text-xs text-foreground-400">
              <i className="ri-lock-line" />
              草稿不会上传，仅供整理思路
            </div>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => setSent(false)}
                className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-600 transition-colors hover:border-foreground-400"
              >
                清空
              </button>
              <button
                type="button"
                onClick={() => setSent(true)}
                className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                提交线索
              </button>
            </div>
          </div>
          {sent ? (
            <p className="mt-3 rounded-md bg-accent-100 px-3 py-2 text-sm text-accent-900">
              投稿通道已为你开启，请通过客户端私信把完整凭证发给编辑部，感谢你的第一时间跟进。
            </p>
          ) : null}
        </div>
      </div>
    </section>
  );
}